<template>
    <div class="container">
        <div :class="`alert alert-${type} alert-dismissible fade show`">
            <strong>{{ type | ucFirst }}!</strong>
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['type', 'message']
    }
</script>
